import React, {useState} from "react";
import Form from "./ConsignmentCommandForm";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {connect} from "react-redux";
import {fromJS, Map} from "immutable";
import {MARK_CONSIGNMENT, REPORT_CONSIGNMENT} from "../../../queries/warehouseTracking";
import {createErrors, createValidationErrors} from "../../../lib/ErrorFormatter";
import {cancelConsignmentCommand, successConsignmentCommand} from "../../../actions/ConsignmentApiActions";
import {validateArrayPresenceWithValue, validatePresence} from "../../../lib/Validators";
import Checkbox from "../../../components/Checkbox";


function validateForm(isReport, values) {
  let errors = Map();
  errors = validatePresence(errors, values, "location");
  if (isReport) {
    errors = validatePresence(errors, values, "message");
  }
  errors = validateArrayPresenceWithValue(errors, values, "trackingNrs", true);
  
  return errors.toJS();
}

const MARK_COMMANDS = {
  PICKED_UP: "picked_up",
  IN_TRANSIT: "in_transit",
  IN_DELIVERY: "in_delivery",
  FOR_RETURN: "for_return",
  RETURNED: "returned",
  DELIVERED: "delivered",
}

const MARK_COMMANDS_OPTIONS = fromJS([
  { id: MARK_COMMANDS.PICKED_UP, title: "Mark as Picked Up" },
  { id: MARK_COMMANDS.IN_TRANSIT, title: "Mark as In Transit" },
  { id: MARK_COMMANDS.IN_DELIVERY, title: "Mark as In Delivery" },
  { id: MARK_COMMANDS.FOR_RETURN, title: "Mark as For Return" },
  { id: MARK_COMMANDS.RETURNED, title: "Mark as Returned" },
  { id: MARK_COMMANDS.DELIVERED, title: "Mark as Delivered" },
])

const REPORT_COMMANDS = {
  EXCEPTION: "exception",
  DISCARDED: "discarded",
  DELIVERY_ATTEMPT: "delivery_attempt",
}

const REPORT_COMMANDS_OPTIONS = fromJS([
  { id: REPORT_COMMANDS.EXCEPTION, title: "Report Exception" },
  { id: REPORT_COMMANDS.DISCARDED, title: "Report Discarded" },
  { id: REPORT_COMMANDS.DELIVERY_ATTEMPT, title: "Report Delivery Attempted" },
])

function ConsignmentCommandFormContainer(props) {
  const {
    consignmentAndActivities,
    report = false,
  } = props;

  const consignment = consignmentAndActivities.get("consignment");
  const commandOptions = report ? REPORT_COMMANDS_OPTIONS : MARK_COMMANDS_OPTIONS;
  const tracking_nr_options = consignment.get("packages").map((p) => Map({id: p.get("trackingNr"), title: p.get("trackingNr")}));
  const locationsTips = fromJS([
    { id: "warehouse", title: formatWarehouseAddress(consignment.get("sender")) },
    { id: "recipient", title: formatRecipientAddress(consignment.get("recipient")) },
  ])

  const [errors, setErrors] = useState([])
  const [trackingNrsSelected, setTrackingNrsSelected] = useState(tracking_nr_options.map((p) => !report));

  function handleSubmit(values) {
    // Tracking numbers come as an array of booleans
    const trackingNrs = values.get("trackingNrs").reduce((acc, b, index) => {
      if (b) {
        acc.push(tracking_nr_options.getIn([index, "id"]));
      }

      return acc
    }, []);

    let updatedValues = values.set("consignmentId", consignment.get("consignmentId"))
                              .set("occurredAtUtcDate", new Date().toISOString())
                              .set("trackingNrs", trackingNrs);

    const consignmentCommand = report ? props.reportConsignment : props.markConsignment;

    return consignmentCommand(updatedValues.toJS())
      .then((response) => {
        const data = report ? response.data.reportConsignment : response.data.markConsignment;

        if (data.errors.length <= 0) {
          setErrors([]);
          props.successConsignmentCommand();
        } else {
          let errors = createValidationErrors(data.errors);
          setErrors(errors);
        }
      })
      .catch((err) => {
        setErrors(createErrors(err));
      });      
  }

  function handleCancel() {
    props.cancelConsignmentCommand();
  }

  const initialValues = Map({
    trackingNrs: trackingNrsSelected,
  });

  function handleToggleAll() {
    if (trackingNrsSelected.includes(false)) {
      setTrackingNrsSelected(trackingNrsSelected.map((s) => true));
    }
    else {
      setTrackingNrsSelected(trackingNrsSelected.map((s) => false));
    }
  }

  return (
    <div>
      <div style={{paddingBottom: "16px", borderBottom: "1px solid var(--grey-300)", marginBottom: "16px"}}>
      {/* Toggle all not part of the redux form */}
      <Checkbox label="(De)Select all packages" checked={!trackingNrsSelected.includes(false)} onClick={handleToggleAll} />
      </div>

      <Form
        withMessageField={report}
        commandOptions={commandOptions}
        tracking_nr_options={tracking_nr_options}
        locationsTips={locationsTips}
        initialValues={initialValues}
        errors={errors}
        validate={(values) => validateForm(report, values)}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        />
    </div>
  )
}

function formatWarehouseAddress(sender) {
  return `Warehouse, ${sender.get("addressCity")}, (${sender.get("addressCountryCode")})`;
}
function formatRecipientAddress(recipient) {
  return `${recipient.get("addressAddressLine1")}, ${recipient.get("addressCity")}, (${recipient.get("addressCountryCode")})`;
}

const withQueries = compose(
  graphql(MARK_CONSIGNMENT, {
    props: ({ mutate }) => ({
      markConsignment: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(REPORT_CONSIGNMENT, {
    props: ({ mutate }) => ({
      reportConsignment: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
);


export default connect(null, {cancelConsignmentCommand, successConsignmentCommand})(withQueries(ConsignmentCommandFormContainer));